export default "__VITE_ASSET__BuSQIzew__"